var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeHotspot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#10ACE3",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 2,
    fill: "#F9F9F9",
    fillRule: "nonzero",
    width: 76,
    height: 76,
    rx: 38
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.06 27.955c3.708 5.359 3.557 12.286-.381 17.5M50.74 31.136a11.289 11.289 0 0 1-.123 11.137M22.68 45.455c-3.708-5.36-3.557-12.287.382-17.5M26.001 42.273a11.289 11.289 0 0 1 .122-11.137M29.185 25.568h18.37M29.185 49.432h18.37M36.839 52.614h3.062M47.555 24.966v28.096a1.956 1.956 0 0 1-.538 1.378 1.8 1.8 0 0 1-1.322.56h-14.65a1.8 1.8 0 0 1-1.322-.56 1.956 1.956 0 0 1-.538-1.378V21.938a1.956 1.956 0 0 1 .538-1.378 1.8 1.8 0 0 1 1.322-.56h11.278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.555 26.364v-4.15c.006-.59-.162-1.157-.464-1.574-.303-.417-.714-.647-1.142-.64h-4.517"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHotspot);
export default __webpack_public_path__ + "static/media/homeHotspot.b092b5cca1b7724b3ee8672325915355.svg";
export { ForwardRef as ReactComponent };